import { UploadedFrom } from './types';

export const callExchangePlaidToken = async (
  apiBasePath: string,
  businessId: string,
  publicToken: string,
  requestBodyParams?: Partial<{
    uploadedFrom?: UploadedFrom;
    analyticsMetadata?: Record<string, unknown>;
    ledgerId?: string;
    preselectionReason?: string;
  }>,
): Promise<Response> => {
  const requestBody: Record<string, unknown> = {
    publicToken,
    uploadedFrom: requestBodyParams?.uploadedFrom,
    analyticsMetadata: requestBodyParams?.analyticsMetadata,
    ledgerId: requestBodyParams?.ledgerId,
    preselectionReason: requestBodyParams?.preselectionReason,
  };

  return fetch(`${apiBasePath}/business/${businessId}/exchange`, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify(requestBody),
  });
};
